const twoFactorAuth = {
  verifyIdentity: "Vérifions votre identité",
  enterOtpMessage:
    "Veuillez rentrer le code à 6 chiffres reçu par email dans le champs ci-dessous.",
  verifyCode: "Code de vérification",
  codeExpiry: "Le code reçu expirera au bout de 5 minutes.",
  sendNewEmail: "Renvoyer un email de vérification. ",
};

export default twoFactorAuth;
